import React, {useState, useContext, useEffect} from 'react';
import './languageSelectorComponent.css';
import Globe from '../../../assets/svgComponents/Globe';
import languagesService from '../../../services/languagesService';
import {AppContext} from '../../../AppModule/Context';
import storageService from '../../../services/storageService';

const LanguageSelectorComponent = ({isPersonalPage, props}) => {
  const [languages] = useState(() => languagesService.getLanguagesLocaleKeys());
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [showDropDown, setShowDropDown] = useState(false);
  const context = useContext(AppContext);

  const handleDropdownChange = (e) => {
    let currentUser = getCurrentUser();
    setUserLanguage(currentUser, e.key, true);
    // to re-render the widget.
    // Todo: The above a walk around in order to re-render the widget. we need to save
    // the language and languageSet in the context and then changing it there will rerender every
    // component that is actually using the language sets.
    setShowDropDown(false);
  };

  useEffect(() => {
    setInitialWidgetLanguage();
    // eslint-disable-next-line
  }, []);

  const setInitialWidgetLanguage = () => {
    // UI Language priority: localStorage ==> mentor ==> widget ==> "ENGLISH"
    let currentUser = getCurrentUser();
    const langLocales = languagesService.getLanguagesLocaleKeys();
    const userWidgetLanguage = storageService.getItem('userWidgetLanguage')
      ? JSON.parse(storageService.getItem('userWidgetLanguage'))
      : {};

    const userLanguage =
      userWidgetLanguage[currentUser?.userId] ||
      props.mentor?.mentorDto?.uiLanguage ||
      props.widgetDto.widgetAppCtrlDto.uiLanguage ||
      languagesService.language;
    if (userLanguage) {
      setUserLanguage(currentUser, userLanguage.toUpperCase());
      let currentLocal = langLocales.find(({key}) => key === userLanguage);
      if (currentLocal) setCurrentLanguage(currentLocal.value);
    } else {
      setUserLanguage(currentUser, 'ENGLISH');
    }
  };

  const setUserLanguage = (currentUser, lang, updateLocalStorage) => {
    context.setLanguage(lang);
    const languageItem = languagesService.languagesLocaleKeys.find(
      (item) => item.key === lang,
    );
    setCurrentLanguage(languageItem.value);

    if (updateLocalStorage) {
      storageService.setItem(
        'userWidgetLanguage',
        JSON.stringify({[currentUser.userId]: lang}),
      );
    }
  };

  const getCurrentUser = () => {
    return context.currentUser;
  };

  const toggleDropDown = () => {
    if (props.isDemo) return;
    setShowDropDown(!showDropDown);
  };
  const getClassName = (name) =>
    isPersonalPage ? `et-personal-lang-${name}` : `et-lang-${name}`;

  return (
    <>
      <div
        className={`${getClassName('side-header')} ${props.isInAgentList ? 'et-lang-agent-list-wrap' : ''}`}>
        <div onClick={toggleDropDown} className="et-lang-language">
          <div
            className={
              isPersonalPage
                ? 'et-personal-page-lang-globe'
                : 'et-widget-lang-globe'
            }>
            <Globe
              fillColor={
                props.isInAgentList
                  ? 'var(--et-team-secondary-text-color)'
                  : 'var(--et-mentor-cta-primary-btn-text-color)'
              }
            />
          </div>
          <div className={getClassName('language-option')}>
            {currentLanguage}
          </div>
        </div>
      </div>

      <div
        className={
          showDropDown ? getClassName('dropdown') : 'et-lang-dropdown-close'
        }>
        {languages.map((item, index) => {
          return (
            <div
              className="et-lang-dropdown-options"
              key={index}
              onClick={() => handleDropdownChange(item)}>
              {item.key}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default LanguageSelectorComponent;
